// angular imports
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// component imports
import { WorkOrderBaseComponent } from '../../../_base/work-order-base-component';

// model imports
import { VendorProposalHistoryParameterDto } from '../../../_models/vendor-proposal-history-parameter-dto';
import { VendorProposalHistoryResultDto } from '../../../_models/vendor-proposal-history-result-dto';

@Component({
    selector: 'app-work-order-proposal-history',
    templateUrl: './work-order-proposal-history.component.html',
    styleUrls: ['./work-order-proposal-history.component.scss']
})
export class WorkOrderProposalHistoryComponent extends WorkOrderBaseComponent implements OnInit {
    @ViewChild('workorderProposalHistoryPopup', { static: false }) workorderProposalHistoryPopup: DxPopupComponent;

    @Input() workOrderProposalId: number;
    @Input() communityId: number;
    @Input() workOrderId: number;

    @Output() onClose = new EventEmitter<void>();

    historySource: Array<VendorProposalHistoryResultDto> = [];

    visible = false;

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.populateWorkOrderProposalHistory();
        this.visible = true;
    }

    onPopupShown(): void {
        this.workorderProposalHistoryPopup.instance.repaint();
    }

    onPopupClose(): void {
        this.closeProposalHistory();
    }

    onDownloadFile(record: VendorProposalHistoryResultDto): void {
        this.helperService.downloadFileUsingUrl(record.proposalDownloadUrl, record.fileName);
    }

    private populateWorkOrderProposalHistory(): void {
        const baseParams: VendorProposalHistoryParameterDto = new VendorProposalHistoryParameterDto();
        baseParams.communityId = this.communityId;
        baseParams.workOrderId = this.workOrderId;
        baseParams.workOrderProposalId = this.workOrderProposalId;

        this.workOrderHelperService.showLoading();
        this.workOrderService.getWorkOrderProposalHistory(baseParams).subscribe(
            (result: VendorProposalHistoryResultDto[]) => {
                this.historySource = result;
                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.workOrderHelperService.hideLoading();
            }
        );
    }

    private closeProposalHistory(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
